export const STRANDS_BY_GRADE = {
  'Grade 11': [
    { code: 'ASSH', label: 'Arts, Social Sciences, and Humanities (ASSH)' },
    { code: 'BAE', label: 'Business and Entrepreneurship (BAE)' },
    { code: 'HAT', label: 'Hospitality and Tourism (HAT)' },
    { code: 'ICT', label: 'Information and Communications Technology (ICT)' },
  ],
  'Grade 12': [
    { code: 'ABM', label: 'Accountancy, Business, and Management (ABM)' },
    { code: 'HUMSS', label: 'Humanities and Social Sciences (HUMSS)' },
    { code: 'HE', label: 'Home Economics (HE)' },
    { code: 'ICT', label: 'Information and Communications Technology (ICT)' },
  ],
};
